<script>
export default {
    name: 'Yampi',
}
</script>

<template>
    <nuxt  />
</template>
